<div class="wrapper">
  <app-header></app-header>

  <main id="main">
    <router-outlet></router-outlet>
  </main>

  <app-toast-global></app-toast-global>
  <app-notifications></app-notifications>
  <app-global-spinner></app-global-spinner>

  <app-footer></app-footer>
</div>
